import { NudgeRecordingRequestSchema, NudgeRecordingResponseSchema } from './nudge-recording.schema';
export const nudgeRecordingContract = {
    method: 'POST',
    path: '/api/v2/recording-dashboard/nudge',
    description: 'Send a nudge/reminder email to a user about a recording task',
    requestSchema: NudgeRecordingRequestSchema,
    responseSchema: NudgeRecordingResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            400: 'Bad Request - invalid input data',
            401: 'Unauthorized - user not authenticated',
            403: 'Forbidden - user lacks Nudge create permission or the target user is not active'
        }
    }
};

//# sourceMappingURL=nudge-recording.contract.js.map